import styled from "styled-components";

export default {
  DivMain: styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 420px;
    height: 100vh;
    background: #ffffff;
    border-left: 1px solid #e5e7eb;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    z-index: 1300;
    display: flex;
    flex-direction: column;
    font-family: "Roboto", sans-serif;

    .div-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 16px;
      border-bottom: 1px solid #f0f0f0;
      position: sticky;
      top: 0;
      background: #ffffff;
      z-index: 1;

      .txt-title {
        font-size: 15px;
        font-weight: 700;
        color: #111827;
        letter-spacing: -0.2px;
      }
    }

    .div-body {
      flex: 1;
      padding: 16px 20px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    /* Trip summary card */
    .div-tripCard {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 14px;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .lbl-key {
          font-size: 12px;
          color: #6b7280;
        }
        .lbl-val {
          font-size: 12px;
          font-weight: 600;
          color: #111827;
        }
      }
    }

    /* Section header */
    .txt-sectionTitle {
      font-size: 12px;
      font-weight: 700;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      margin-bottom: 8px;
      display: block;
    }

    /* Alert banners */
    .div-alertNoDrivers {
      background: #fef2f2;
      border: 1px solid #fecaca;
      border-radius: 10px;
      padding: 14px;
      display: flex;
      align-items: flex-start;
      gap: 10px;

      .icon-alert { font-size: 22px; }
      .txt-alert { font-size: 13px; color: #dc2626; font-weight: 600; margin: 0; }
      .txt-sub { font-size: 11px; color: #ef4444; margin-top: 2px; display: block; }
    }

    .div-alertHasDrivers {
      background: #fff7ed;
      border: 1px solid #fed7aa;
      border-radius: 10px;
      padding: 14px;
      display: flex;
      align-items: flex-start;
      gap: 10px;

      .icon-alert { font-size: 22px; }
      .txt-alert { font-size: 13px; color: #c2410c; font-weight: 600; margin: 0; }
      .txt-sub { font-size: 11px; color: #ea580c; margin-top: 2px; display: block; }

      &.success {
        background: #f0fdf4;
        border-color: #bbf7d0;
        .txt-alert { color: #15803d; }
        .txt-sub { color: #16a34a; }
      }

      &.info {
        background: #eff6ff;
        border-color: #bfdbfe;
        .txt-alert { color: #1d4ed8; }
        .txt-sub { color: #2563eb; }
      }
    }

    /* Driver audit rows */
    .div-driversList {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .div-driverRow {
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      gap: 6px;
      transition: border-color 0.2s;

      &:hover { border-color: #d1d5db; }

      &.notified {
        border-left: 3px solid #10b981;
      }
      &.not-notified {
        border-left: 3px solid #f59e0b;
      }
      &.no-token {
        border-left: 3px solid #ef4444;
      }

      .row-name {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .txt-name {
          font-size: 13px;
          font-weight: 700;
          color: #111827;
        }
        .txt-tel {
          font-size: 11px;
          color: #6b7280;
          margin-top: 1px;
        }
      }

      .row-stats {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;

        .stat {
          background: #f8fafc;
          border-radius: 6px;
          padding: 4px 8px;
          font-size: 11px;
          color: #374151;
          font-weight: 500;
        }
      }

      .row-badges {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
        margin-top: 2px;
      }

      .badge {
        border-radius: 20px;
        padding: 2px 10px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.3px;

        &.badge-ws { background: #d1fae5; color: #065f46; }
        &.badge-no-ws { background: #fef3c7; color: #92400e; }
        &.badge-push { background: #e0f2fe; color: #0c4a6e; }
        &.badge-no-push { background: #fee2e2; color: #7f1d1d; }
      }
    }

    /* Empty audit */
    .div-noAudit {
      text-align: center;
      padding: 30px 0;
      color: #9ca3af;
      font-size: 13px;
    }

    /* Loading/Error */
    .div-loading, .div-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 20px;
      gap: 8px;

      .txt-loading { font-size: 13px; color: #9ca3af; }
      .txt-error { font-size: 13px; color: #ef4444; text-align: center; }
    }
  `,
};
